import Vue from 'vue'
import Router from 'vue-router'
import LoginForm from '@/components/login/LoginForm';
import Dashboard from '@/components/personal/Dashboard';
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'LoginForm',
      component: LoginForm
    },
    {
      path: '/dashboard/',
      name: 'Dashboard',
      component: Dashboard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js